module.exports = __webpack_public_path__ + "assets/img/W2-1-F.78c6c58f.png";